import { createRouter, createWebHistory } from 'vue-router'
import NotFound from '../views/NotFound.vue'
import store from '../shared/store'
import Login from '../views/auth/Login.vue'
import Dashboard from '../views/dashboards/index.vue'
import { useStore } from 'vuex'
import { useLoaderStore } from '../shared/store/loader'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../layout/index.vue'),
        meta: {
            title: 'dashboard',
            requiresAuth: true
        },
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('../views/dashboards/index.vue'),
                meta: {
                    title: 'Dashboard',
                    requiresAuth: true
                }, 
            },
            {
                path: '/financeiro',
                name: 'financial',
                component: () => import('../views/payments/index.vue'),
                meta: {
                    module: 'payments',
                    title: 'Financeiro',
                    icon: 'i-Money-2',
                    requiresAuth: true
                },
            },
            {
                path: '/usuarios',
                name: 'users',
                component: () => import('../views/users/index.vue'),
                meta: {
                    module: 'users',
                    title: 'Usuários',
                    icon: 'i-Administrator',
                    requiresAuth: true
                },
            },

            {
                path: '/lembretes',
                name: 'reminders',
                component: () => import('../views/reminders/index.vue'),
                meta: {
                    module: 'reminders',
                    title: 'Lembretes',
                    icon: 'i-Bell',
                    requiresAuth: true
                },
            },

            {
                path: '/centro-de-custo',
                name: 'cost_center',
                component: () => import('../views/settings/index.vue'),
                meta: {
                    module: 'cost_center',
                    title: 'Centro de custo',
                    icon: 'i-Gear-2',
                    requiresAuth: true
                },
            },
            {
                path: '/departamentos',
                name: 'departments',
                component: () => import('../views/settings/index.vue'),
                meta: {
                    module: 'departments',
                    title: 'Departamentos',
                    icon: 'i-Gear-2',
                    requiresAuth: true
                },
            },
            {
                path: '/cargos',
                name: 'positions',
                component: () => import('../views/settings/index.vue'),
                meta: {
                    module: 'positions',
                    title: 'Cargos',
                    icon: 'i-Gear-2',
                    requiresAuth: true
                },
            },
            {
                path: '/categorias',
                name: 'categories',
                component: () => import('../views/settings/index.vue'),
                meta: {
                    module: 'categories',
                    title: 'categorias',
                    icon: 'i-Gear-2',
                    requiresAuth: true
                },
            },
            {
                path: '/relatorios',
                name: 'reports',
                component: () => import('../views/reports/index.vue'),
                meta: {
                    module: 'reports',
                    title: 'relatorios',
                    icon: 'i-File-Chart',
                    requiresAuth: true
                },
            },
        ]
        
    },
    { path: '/login', component: Login },
    { path: '/:path(.*)', component: NotFound },
      /*{
        
      
        path: '/layout',
        name: 'Home',
        component: () => import('../layout/index.vue'),
        redirect: '/',
        meta: {
            title: 'dashboard',
        },
        children: [
            {
                path: '/dashboards',
                name: 'Dashboards',
                component: () => import('../views/dashboards/index.vue'),
                meta: {
                    title: 'Dashboard',
                },
                children: [
                    {
                        path: 'dashboard-version-one',
                        name: 'dashboard-version-one',
                        component: () =>
                            import('../views/dashboards/Dashboards.v1.vue'),
                    },
                ],
            },
            {
                path: '/components',
                name: 'components',
                component: () => import('../views/components/index.vue'),
                meta: {
                    title: 'Components',
                },
                children: [
                    {
                        path: 'button',
                        name: 'button',
                        component: () =>
                            import('../views/components/Button.vue'),
                    },
                ],
            },
            {
                path: '/profile',
                name: 'profile',
                component: () => import('../views/profile/index.vue'),
                meta: {
                    title: 'Profile',
                },
                children: [
                    {
                        path: 'profileTwo',
                        name: 'ProfileTwo',
                        component: () =>
                            import('../views/profile/ProfileTwo.vue'),
                    },
                ],
            },
        ],
        
    },
    {
        path: '/dashboard',
        name: 'Home',
        component: () => import('../layout/index.vue'),
        redirect: '/',
        meta: {
            title: 'dashboard',
        },
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('../views/dashboards/index.vue'),
                meta: {
                    title: 'Dashboard',
                    requiresAuth: true
                }, 
            },
            {
                path: '/',
                name: '',
                redirect: '/dashboard',
                component: () => import('../layout/content.vue'),
                children: [
                    {
                        path: '/financeiro',
                        name: 'financial',
                        component: () => import('../views/payments/index.vue'),
                        meta: {
                            module: 'Financeiro',
                            title: '',
                            requiresAuth: true
                        },
                    },
                    {
                        path: '/financeiro/cadastrar',
                        name: 'financial.create',
                        component: () => import('../views/financial/create.vue'),
                        meta: {
                            module: 'Financeiro',
                            title: 'Cadastrar',
                            requiresAuth: true
                        },
                    },
                    {
                        path: '/colaboradores',
                        name: 'users',
                        component: () => import('../views/users/index.vue'),
                        meta: {
                            module: 'users',
                            title: 'Colaboradores',
                            requiresAuth: true
                        },
                    },

                    {
                        path: '/lembretes',
                        name: 'reminders',
                        component: () => import('../views/reminders/index.vue'),
                        meta: {
                            module: 'Lembretes',
                            title: '',
                            requiresAuth: true
                        },
                    },

                    {
                        path: '/centro-de-custo',
                        name: 'cost_center',
                        component: () => import('../views/settings/index.vue'),
                        meta: {
                            module: 'cost_center',
                            title: 'Centro de custo',
                            requiresAuth: true
                        },
                    },
                    {
                        path: '/departamentos',
                        name: 'departments',
                        component: () => import('../views/settings/index.vue'),
                        meta: {
                            module: 'departments',
                            title: 'Departamentos',
                            requiresAuth: true
                        },
                    },
                    {
                        path: '/cargos',
                        name: 'positions',
                        component: () => import('../views/settings/index.vue'),
                        meta: {
                            module: 'positions',
                            title: 'Cargos',
                            requiresAuth: true
                        },
                    },
                    

                    
                ]
            }
        ]
    },
    

    { path: '/login', component: Login },
    { path: '/signUp', component: SignUp },
    { path: '/:path(.*)', component: NotFound },
     */
]

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        return { left: 0, top: 0 }
    },
    routes,
});

router.afterEach(() => {
    if (window.innerWidth <= 1200) {
        const sidenav = store.state.largeSidebar.sidebarToggleProperties.isSideNavOpen
        store.commit('largeSidebar/toggleSidebarProperties')
    }

    const loader = useLoaderStore();
    console.log('fechar loader')
    setTimeout(() => loader.hide(), 500);
});

router.beforeEach((to, from, next) => {
    const store = useStore();
    const loader = useLoaderStore();
    loader.show();
    if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
      return next('/login'); // Redireciona para o login se não estiver autenticado
    } else {
      next();
    }
  });

export default router
